module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "main"
  }, [_c('h2', [_vm._v("订单信息")]), _vm._v(" "), _c('ul', [_c('li', [_c('label', [_vm._v("产品名称：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info.productName))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("产品编号：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info.productNo))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("订单号：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info.id))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("订单状态：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info.orderStatusStr))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("下单时间：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info.orderCreateTime))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("订单金额：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info.totalPrice))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("物流公司：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info.deliverName))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("物流单号：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info.deliverNo))])])]), _vm._v(" "), _c('h2', [_vm._v("退款")]), _vm._v(" "), _c('ul', [_c('li', [_c('label', [_vm._v("退款条件：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info.refundCondition))])])]), _vm._v(" "), _c('h2', [_vm._v("历史退款")]), _vm._v(" "), _c('v-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "column": _vm.tableColumn
    },
    scopedSlots: _vm._u([{
      key: "refundNo",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "word-break": "break-all"
          }
        }, [_vm._v(_vm._s(props.data))])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7420430","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/wenchuang/orderDetails/Main.vue
// module id = 947
// module chunks = 0